'use strict';

var cov_7jxaxze69 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/userHistory/userHistory.js',
        hash = 'f2921ed009727fb6f5dd1ca9711832491fb9b489',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/userHistory/userHistory.js',
        statementMap: {
            '0': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 12
                },
                end: {
                    line: 9,
                    column: 52
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 12
                },
                end: {
                    line: 10,
                    column: 31
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 38
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 39
                }
            },
            '6': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 19
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 4
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 15
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 8,
                        column: 48
                    },
                    end: {
                        line: 8,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 69
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 8
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 4
                    },
                    end: {
                        line: 14,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 16
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 14
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserHistoryController = function () {
    function UserHistoryController() {
        _classCallCheck(this, UserHistoryController);

        cov_7jxaxze69.f[0]++;
    }

    _createClass(UserHistoryController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_7jxaxze69.f[1]++;
            cov_7jxaxze69.s[0]++;

            this.user.$load('executions');

            cov_7jxaxze69.s[1]++;
            this.user.$executions.$on('after-feed', function (execution) {
                cov_7jxaxze69.f[2]++;
                cov_7jxaxze69.s[2]++;

                this.day = execution.start.slice(0, 10);
                cov_7jxaxze69.s[3]++;
                this.$load('task');
            });
        }
    }, {
        key: 'nextPage',
        value: function nextPage() {
            cov_7jxaxze69.f[3]++;
            cov_7jxaxze69.s[4]++;

            this.user.$executions.$page++;
            cov_7jxaxze69.s[5]++;
            this.user.$executions.$fetch();
        }
    }]);

    return UserHistoryController;
}();

cov_7jxaxze69.s[6]++;


angular.module('app').component('userHistory', {
    templateUrl: 'app/components/userHistory/userHistory.html',
    controller: UserHistoryController,
    bindings: {
        user: '<'
    }
});